import styled from 'styled-components';
import { AVideoAspectRatio } from './AVideo.types';

const getAspectRatioValue = (ratio: AVideoAspectRatio): string => {
  switch (ratio) {
    case AVideoAspectRatio.Ratio1x1:
      return '1 / 1';
    case AVideoAspectRatio.Ratio2x3:
      return '2 / 3';
    case AVideoAspectRatio.Ratio5x2:
      return '5 / 2';
    case AVideoAspectRatio.Ratio16x9:
      return '16 / 9';
    case AVideoAspectRatio.Ratio3x2:
      return '3 / 2';
    default:
      return '16 / 9';
  }
};

export const VideoWrapper = styled.div<{ aspectRatio: AVideoAspectRatio }>`
  position: relative;
  width: 100%;
  aspect-ratio: ${({ aspectRatio }) => getAspectRatioValue(aspectRatio)};
  overflow: hidden;
  border-radius: var(--t-images-border-radius, 14px);
`;

export const VideoElement = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;
